import { useMemo } from "react"
import { Grid } from "@mui/material"
import fp from "lodash/fp"

import { useTranslation } from "react-i18next"
import useDevices from "helpers/hooks/useDevices"
import HomePieChartsSkeleton from "widgets/skeletons/HomePieChartsSkeleton"
import Message from "widgets/common/Message"
import DeviceInstallationSubtitle from "./DeviceInstallationSubtitle"
import OrgDevicesByStatusPieChart from "./OrgDevicesByStatusPieChart"
import OrgDevicesByAlertStatusPieChart from "./OrgDevicesByAlertStatusPieChart"

const OrgPieCharts = () => {
  const { devicesByInstallationStatus, isLoading, isUninitialized, isError } =
    useDevices()
  const { t } = useTranslation()

  const areExistingDevices = useMemo(
    () => !fp.isEmpty(devicesByInstallationStatus.installed),
    [devicesByInstallationStatus],
  )

  const installationSubtitle = useMemo(
    () => (
      <DeviceInstallationSubtitle
        installedCount={fp.size(devicesByInstallationStatus.installed)}
        notInstalledCount={fp.size(devicesByInstallationStatus.notInstalled)}
      />
    ),
    [devicesByInstallationStatus],
  )

  const showSkeleton = isLoading || isUninitialized
  const showCharts = !showSkeleton && areExistingDevices

  return (
    <>
      {showSkeleton && <HomePieChartsSkeleton />}
      {showCharts && (
        <Grid item xs={12} data-testid="pie-charts-grid">
          <Grid container spacing={1.5}>
            <OrgDevicesByStatusPieChart
              devsWRelsByIdWStates={devicesByInstallationStatus.installed}
              subtitle={installationSubtitle}
            />
            <OrgDevicesByAlertStatusPieChart
              devsWRelsByIdWStates={devicesByInstallationStatus.installed}
              subtitle={installationSubtitle}
            />
          </Grid>
        </Grid>
      )}
      {isError && (
        <Message
          messageKey="error.FETCHING_ITEM"
          messageOptions={{ item: t("generic.DEVICES") }}
          type="error"
        />
      )}
    </>
  )
}

export default OrgPieCharts
